// var md = new MobileDetect(window.navigator.userAgent);
AOS.init({
	disable: 'mobile'
});
var $ = jQuery.noConflict();


function initAnimations() {
	if (jQuery('.in-view-bottom').length > 0) {
		enterView({
			selector: '.in-view-bottom',
			offset: 0,
			enter: function (element) {
				handleInView(element);
			},
			exit: function (element) {
				handleOutView(element);
			},
		});
	}
	if (jQuery('.in-view').length > 0) {
		enterView({
			selector: '.in-view',
			offset: 0.1,
			enter: function (element) {
				handleInView(element);
			},
			exit: function (element) {
				handleOutView(element);
			},
		});
	}
	if (jQuery('.in-view-middle').length > 0) {
		enterView({
			selector: '.in-view-middle',
			offset: 0.5,
			enter: function (element) {
				handleInView(element);
			},
			exit: function (element) {
				handleOutView(element);
			},
		});
	}
	if (jQuery('.animated-block').length > 0) {
		enterView({
			selector: '.animated-block',
			offset: 0.05,
			enter: function (element) {
				handleInView(element);
			},
			exit: function (element) {
				handleOutView(element);
			},
		});
	}
	if (jQuery('.in-view-top').length > 0) {
		enterView({
			selector: '.in-view-top',
			offset: 0.7,
			enter: function (element) {
				handleInView(element);
			},
			exit: function (element) {
				handleOutView(element);
			},
		});
	}
}

$(document).ready(function () {

	var swiper = new Swiper('.swiper-block', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		speed: 600,
		loop: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 5000,
		},
	});
	setTimeout(function () {
		jQuery('.map-wrapper,.siteplan-wrapper').scrollLeft(330);
	}, 300);

	$('.single-events li').removeClass('current_page_parent');
	$('.single-events #menu-item-44').addClass('current-menu-item');
	var carousels = [];

	$('.carousel-block').each(function () {
		var tt = $(this);
		carousels.push(new Swiper(tt[0], {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 10,
			navigation: {
				nextEl: tt.find('.swiper-button-next')[0],
				prevEl: tt.find('.swiper-button-prev')[0],
			},
			speed: 1250,
			loop: true,
			autoplay: {
				disableOnInteraction: false,
				delay: 5000,
			},
		}));
	});

	$('.icon-carousel').each(function () {
		var tt = $(this);
		carousels.push(new Swiper(tt[0], {
			slidesPerView: 4,
			spaceBetween: 10,
			// navigation: {
			// 	nextEl: tt.find('.swiper-button-next')[0],
			// 	prevEl: tt.find('.swiper-button-prev')[0],
			// },
			speed: 1000,
			loop: true,
			autoplay: {
				disableOnInteraction: false,
				delay: 3000,
			},
		}));
	});

	updateCarousels();
	setTimeout(function () {

		updateCarousels();
	}, 1000);
	var imgs = document.images,
		len = imgs.length,
		counter = 0;

	[].forEach.call(imgs, function (img) {
		if (img.complete)
			incrementCounter();
		else
			img.addEventListener('load', incrementCounter, false);
	});

	function incrementCounter() {
		counter++;
		if (counter === len) {
			updateCarousels();
		}
	}

	function updateCarousels() {
		for (var carousel of carousels) {
			carousel.update();
		}
	}


	$('.tenants-legend-item').click(function () {
		$('.tenants-legend-item').removeClass('active');
		$(this).addClass('active');
		var index = $(this).index();

		$('.tenant-item').hide().eq(index).show();
	});
	$('.tenants-legend-item').last().trigger('click');

	$('.menu-bt').click(function () {
		$(this).toggleClass('is-active');
		$('header').toggleClass('is-active');

	});

	var legendTimeout1, legendTimeout2, legendTimeout3, legendTimeout4, legendTimeout5;
	var timouetNumber = 50;

	$("#legend5").mouseenter(function () {
		clearTimeout(legendTimeout5);
		$('#none_selected').css('opacity', 0);
		$("#tram_pink").attr('class', '');
	}).mouseleave(function () {
		legendTimeout5 = setTimeout(function () {
			$("#tram_pink").attr('class', 'st68');
			$('#none_selected').css('opacity', 1);
		}, timouetNumber);
	});

	$("#legend4").mouseenter(function () {
		clearTimeout(legendTimeout4);
		$('#none_selected').css('opacity', 0);
		$("#tram_orange").attr('class', '');
	}).mouseleave(function () {
		legendTimeout4 = setTimeout(function () {
			$('#none_selected').css('opacity', 1);
			$("#tram_orange").attr('class', 'st68');
		}, timouetNumber);
	});

	$("#legend3").mouseenter(function () {
		clearTimeout(legendTimeout3);
		$('#none_selected').css('opacity', 0);
		$("#tram_blue_2").attr('class', '');
	}).mouseleave(function () {
		legendTimeout3 = setTimeout(function () {
			$('#none_selected').css('opacity', 1);
			$("#tram_blue_2").attr('class', 'st68');
		}, timouetNumber);
	});

	$("#legend2").mouseenter(function () {
		clearTimeout(legendTimeout2);
		$('#none_selected').css('opacity', 0);
		$("#train").attr('class', '');
	}).mouseleave(function () {
		legendTimeout2 = setTimeout(function () {
			$('#none_selected').css('opacity', 1);
			$("#train").attr('class', 'st68');
		}, timouetNumber);
	});

	$("#legend1").mouseenter(function () {
		clearTimeout(legendTimeout1);
		$('#none_selected').css('opacity', 0);
		$("#tram_blue_1").attr('class', '');
	}).mouseleave(function () {
		legendTimeout1 = setTimeout(function () {
			$('#none_selected').css('opacity', 1);
			$("#tram_blue_1").attr('class', 'st68');
		}, timouetNumber);
	});


	var siteplanClass = 'st7';
	if ($('.interactive-siteplan.pl').length > 0) {
		siteplanClass = 'st8';
	}


	$("#siteplan1").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #train").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #train").attr('class', siteplanClass);
	});


	$("#siteplan2").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #airport").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #airport").attr('class', siteplanClass);
	});

	$("#siteplan3,#siteplan4").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #chill_out_areas").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #chill_out_areas").attr('class', siteplanClass);
	});

	$("#siteplan5,#siteplan6,#siteplan7").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #underground_parking").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #underground_parking").attr('class', siteplanClass);
	});

	$("#siteplan8,#siteplan9,#siteplan10").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #surface_parking").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #surface_parking").attr('class', siteplanClass);
	});
	$("#siteplan11,#siteplan12,#siteplan13").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #entrances").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #entrances").attr('class', siteplanClass);
	});

	$("#siteplan14").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #bike_path").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #bike_path").attr('class', siteplanClass);
	});

	$("#siteplan15,#siteplan16,#siteplan17").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #buses").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #buses").attr('class', siteplanClass);
	});
	$("#siteplan18,#siteplan19").mouseenter(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 0);
		$(".interactive-siteplan #trams").attr('class', '');
	}).mouseleave(function () {
		$('.interactive-siteplan #none_selected').css('opacity', 1);
		$(".interactive-siteplan #trams").attr('class', siteplanClass);
	});

	initAnimations();
});


function handleInView(element) {
	jQuery(element).addClass('is-in-view-first is-in-view');
}

function handleOutView(element) {

	jQuery(element).removeClass('is-in-view');
}
